// extracted by mini-css-extract-plugin
export default {"container":"cYX0XhtoBO7JrBrQgp8V","text":"ffBqe6UE_8TMRpPJqEkq","child":"Vm4DyKlHLxNn32feg471"};